import {
   createTheme,
   lightThemePrimitives, ThemeProvider
} from "baseui";
import { Avatar } from "baseui/avatar";
import {
   ALIGN, HeaderNavigation,
   StyledNavigationItem, StyledNavigationList
} from "baseui/header-navigation";
import { PLACEMENT, StatefulPopover } from 'baseui/popover';
import {H5, Label4} from 'baseui/typography';
import React from 'react';
import { connect } from 'react-redux';
import { useStyletron } from 'styletron-react';
import { AuthUserContext } from '../firebase/session';
import ProfileDropdown from './ProfileDropdown';
import {StyledLink} from "baseui/link";
import {setAdminMode} from "../actions/ui";


const UserAvatar = () => {
   let { loading } = React.useContext(AuthUserContext);
   return !loading ? <Avatar size="scale1400" src={'/profile.png'} /> : '';
}

const ToolBar = ({setAdminMode}) => {
   const [css] = useStyletron();
   let { authUser } = React.useContext(AuthUserContext);
   let impersonating = authUser && authUser.impersonate;

   return (

      <HeaderNavigation overrides={{
         Root: {
            style: ({ $theme }) => {
               return {
                  height: '80px'
               };
            }
         }
      }}>
         <ThemeProvider
            theme={createTheme(lightThemePrimitives, {
               colors: {
                  buttonPrimaryFill: "#F6F6F6F6",
                  buttonPrimaryText: "#000000",
                  buttonPrimaryHover: "#AAAAAA",
                  buttonPrimaryActive: "#777777"
               }
            })}
         >
            <StyledNavigationList $align={ALIGN.left}>
               <StyledNavigationItem>
                  <H5 margin="scale500">
                     Living Ledger</H5>
               </StyledNavigationItem>
            </StyledNavigationList>
         </ThemeProvider>
         <StyledNavigationList $align={ALIGN.center}>
         </StyledNavigationList>
         <StyledNavigationList $align={ALIGN.right}>
            {
               impersonating && impersonating.email ?
                   <StyledNavigationItem>
                     <div style={{display: 'flex'}}>
                         <div style={{flexDirection: 'column'}}>
                            <Label4>Viewing: {impersonating.email}'s account</Label4>
                            <StyledLink onClick={() => {
                               setAdminMode(false)
                            }}>Log Out</StyledLink>
                         </div>
                     </div>
                  </StyledNavigationItem> : undefined
            }
            <StatefulPopover
               content={() => <ProfileDropdown />}
               placement={PLACEMENT.bottomRight}
               returnFocus
               autoFocus
               ignoreBoundary
               overrides={{
                  Body: {
                     style: { zIndex: 100 }
                  }
               }}
            >
               <StyledNavigationItem className={css({
                  marginRight: '40px',
                  marginLeft: '20px'
               })}>
                  <UserAvatar />
               </StyledNavigationItem>
            </StatefulPopover>
         </StyledNavigationList>
      </HeaderNavigation>
   )
}

export default connect(state => ({}), {
   setAdminMode
})(ToolBar);